export interface TourStepItem {
  description: string
  label: string
}

export interface TourRule {
  label: string
  value: string
}
